module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-plan_rate-reservation-rates"
  }, [_c('ModalReveal', {
    ref: "revealPlanCreate"
  }, [_c('div', {
    staticClass: "button button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Add for " + _vm._s(_vm.bookingMode))]), _c('h2', [_vm._v("Plan reservation rate for " + _vm._s(_vm.bookingMode))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan_rate.name),
      expression: "plan_rate.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.plan_rate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.plan_rate, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Vehicle Category"), _c('selectize-category', {
    on: {
      "optionSelected": _vm.selectCategory
    }
  })], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Reservation rate"), _c('selectize-reservation-rate', {
    on: {
      "optionSelected": _vm.selectRate
    }
  })], 1), _c('label', [_vm._v("Disabled"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.plan_rate.disabled),
      expression: "plan_rate.disabled"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.plan_rate.disabled) ? _vm._i(_vm.plan_rate.disabled, null) > -1 : (_vm.plan_rate.disabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.plan_rate.disabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.plan_rate, "disabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.plan_rate, "disabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.plan_rate, "disabled", $$c)
        }
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns text-right"
  }, [_c('ActionButton', {
    attrs: {
      "action": _vm.savePlanRate
    }
  }, [_vm._v("Save")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63e49788!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/CreatePlanReservationRates.vue
// module id = 2540
// module chunks = 1